const DB_NAME = 'fillbillonline'
const STORAGE_NAME = 'packages'
const DB_VERSION = 1
let DB

export default {
  async getDb () {
    return new Promise((resolve, reject) => {
      if (DB) {
        return resolve(DB)
      }
      const request = window.indexedDB.open(DB_NAME, DB_VERSION)
      request.onerror = e => {
        console.log('Error opening db', e)
        reject('Error')
      }
      request.onsuccess = e => {
        DB = e.target.result
        resolve(DB)
      }
      request.onupgradeneeded = e => {
        let db = e.target.result
        db.createObjectStore(STORAGE_NAME, { autoIncrement: true, keyPath: 'id' })
      }
    })
  },
  async getPackageData () {
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readonly')
      trans.oncomplete = () => {
        resolve(documents)
      }
      const store = trans.objectStore(STORAGE_NAME)
      const documents = []
      store.openCursor().onsuccess = e => {
        const cursor = e.target.result
        if (cursor) {
          documents.push(cursor.value)
          cursor.continue()
        }
      }
      return documents
    })
  },
  async deletePackageData (id) {
    const db = await this.getDb()
    return new Promise(resolve => {
      const trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      const store = trans.objectStore(STORAGE_NAME)
      store.delete(id)
    })
  },
  async updatePackageData (data) {
    const documents = await this.getPackageData()
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      if (documents && documents.length > 0) {
        const mergedData = Object.assign(documents[0], data)
        store.put(mergedData)
      } else {
        store.put(data)
      }
    })
  },
  async deleteGoodFromPackageData (index) {
    const documents = await this.getPackageData()
    documents[0].commissionShipment.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.splice(index, 1)
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      store.put(documents[0])
    })
  },
  async deleteGoodFromHouseshipmentData (index) {
    const documents = await this.getPackageData()
    documents[0].houseShipment.GOODS.GOODS_ITEM.splice(index, 1)
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      store.put(documents[0])
    })
  },
  async addUnsavedNewGood (data) {
    const documents = await this.getPackageData()
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      const packageWithUnsavedNewGood = Object.assign(documents[0], { unsavedNewGood: data })
      store.put(packageWithUnsavedNewGood)
    })
  },
  async deleteUnsavedNewGood () {
    const documents = await this.getPackageData()
    delete documents[0].unsavedNewGood
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      store.put(documents[0])
    })
  },
  async addUnsavedHouseshipments (data) {
    const documents = await this.getPackageData()
    let db = await this.getDb()
    return new Promise(resolve => {
      let trans = db.transaction([STORAGE_NAME], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }
      let store = trans.objectStore(STORAGE_NAME)
      const ecrWithUnsavedHouseshipments = Object.assign(documents[0], { unsavedHouseshipments: { ...data } })
      store.put(ecrWithUnsavedHouseshipments)
    })
  },
}
